const bodyHasClass = (className) => $('body').hasClass(className);

const isAccountPage = (accountPage) => bodyHasClass('page-template-page-account-' + accountPage);

/**
 * Generates the query variables for the listUserSubscriptions resolver based on the current hostname
 * 
 * @returns {object} The variables sent to the listUserSubscriptions resolver
 */
const listUserSubscriptionsVariables = () => {
    let variables = {};

    // Hack for One Parking
    if (/oneparking/.test(window.location.host)) {
        return variables;
    }

    // Hack for Icon and Platinum
    const paymentProviderId = !/platinum|icon/.test(window.location.host) ? 1 : 2;
    return { paymentProviderId };
}

/**
 * Hides/shows saved payment methods based on the data-payment-provider attribute
 * 
 * @param {string} paymentProviderId - The payment provider identifier for the selected subscription/invoice
 */
const hidePaymentProviderPaymentMethods = (paymentProviderId) => {
    $('.payment-method-option').each(function () {
        // if the payment method has the same paymentProviderId in its data attribute,
        // show the payment method. Otherwise, hide it.
        const paymentMethodProviderId = $(this).attr('data-payment-provider');

        if (paymentMethodProviderId === paymentProviderId) {
            $(this).show();
        } else {
            $(this).hide();
        }
    })
}

/** 
 * Sets up currency masking for One-Time Payment's custom amount input
 * @param {number} maxAmount - The maximum allowed value that can be input
 */
const setupCurrencyMask = (maxAmount) => {
    const partialAmountInput = $('#partial-amount-input');
    Inputmask('currency', {
        prefix: '$ ',
        unmaskAsNumber: true,
        min: 0,
        max: maxAmount
    }).mask(partialAmountInput);

    partialAmountInput.inputmask('setvalue', maxAmount);
}
